import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { Input, Select, FallbackImage, Render, Button, Table, Pagination, Modal } from 'components';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { VehicleService } from 'services';
import { CheckCircleIcon, AlertTriangleIcon } from 'assets/icons';
import ModalFiles from './modal-files';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: ''
}

class Vehicles extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Item',
			'Placa',
			'Marca',
			'Año',
			'Modelo',
			'Tipo',
			'Documentación',
			'¿Vehículo activo?',
			'Opciones'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible_files: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Administrar vehículos',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading = false) => {
		const res: any = await VehicleService.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form
		});
		this.setState({
			data: res.vehicles?.rows?.map((item: any, index: number) => {
				item._index = (this.state.page - 1) * Constants.PER_PAGE + (index + 1)
				return item;
			}) || [],
			last_page: res.vehicles?.count || 1
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	changeStatus = (item: any) => {
		Globals.confirm('¿Desea cambiar de estatus al vehículo?',async () => {
			await VehicleService.changeStatus({
				vehicle_id: item.id
			});
			this.load(true);
		});
	}

	create = () => {
		this.props.history.replace(`/${ this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'moderators' }/vehicles/create`);
	}

	delete = (item: any) => {
		Globals.confirm('¿Desea eliminar el vehículo?',async () => {
			await VehicleService.delete({
				vehicle_id: item?.id
			});
			this.load(true);
		});
	}

	onCloseFiles = () => {
		this.setState({
			visible_files: false,
			item: null
		});
	}

	viewFiles = (item: any) => {
		this.setState({
			visible_files: true,
			item
		});
	}

	render() {
		const { visible_files } = this.state;

		return (
			<div id="vehicles">
				<Modal
		          className="modal-view-vehicle-files"
		          visible={ visible_files }
		          title="Permisos"
		          onClose={ () => this.onCloseFiles() }
		        >
		        	{/*
		        	// @ts-ignore */}
		        	<ModalFiles
		        		item={ this.state.item }
		        	/>
		      	</Modal>

				<div className="row row-white">
					<div className="col-md-6">
						<p className="title-white active">Vehículos Registrados</p>
						{/*<p className="title-white" onClick={ () => {
							this.props.history.replace(`/${ this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'moderators' }/vehicles/complete`);
						} }>Completar Registro</p>*/}
					</div>
					<div className="col-md-6">
						<div className="container-add">
							<Input
								value={ this.state.form.search }
								name="search"
								placeholder="Buscar"
								className="input-table"
								notMui
								searchRight
								onChange={ (e: any) => {
									clearTimeout(this.timer);
									this.timer = setTimeout(() => {
										this.load(true);
									},1000);
									this.change(e); 
								} } />
							<button className="btn" onClick={ () => this.create() }>
								<p>Añadir vehículo</p>
								<div className="add">
									+
								</div>
							</button>
						</div>
					</div>
				</div>

				<Table title="Vehículos" data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						const insurance_policy = i.files?.find((item: any) => item.type == Constants.VEHICLE_FILES.INSURANCE_POLICY);
						const vehicle_card = i.files?.find((item: any) => item.type == Constants.VEHICLE_FILES.VEHICLE_CARD);

						return (
							<tr key={ index }>
								<td>{ i._index }</td>
								<td>{ i.plate }</td>
								<td>{ i.brand }</td>
								<td>{ i.year }</td>
								<td>{ i.model }</td>
								<td>{ i.category }</td>
								<td>
									{
										(insurance_policy && vehicle_card) ? (
											<button className="btn btn-green" onClick={ (e: any) => {
												e.preventDefault();
											} }>
												<img src={ CheckCircleIcon } />
												Completa
											</button>
										) : (
											<button className="btn btn-danger" onClick={ (e: any) => {
												e.preventDefault();
											} }>
												<img src={ AlertTriangleIcon } />
												Incompleto
											</button>
										)
									}									
									<a href="#" onClick={ (e: any) => {
										e.preventDefault();
										this.props.history.replace(`/${ this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'moderators' }/vehicles/create/` + i?.id);
									} }>
										Ver
									</a>
								</td>
								<td>
									<div className="check-container">
										<div className={ `check ${ i.status == Constants.VEHICLE_STATUS.ACTIVE ? 'active' : '' }` } onClick={ () => this.changeStatus(i) }>
											<div className="check-circle"></div>
										</div>
										<p className="label-status">{ i.status == Constants.VEHICLE_STATUS.ACTIVE ? 'Si' : 'No' }</p>
									</div>
								</td>
								<td>
									<button className="btn btn-update" onClick={ () => {
										this.props.history.replace(`/${ this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'moderators' }/vehicles/create/` + i?.id);
									}}>
										Editar
									</button>
									<button className="btn btn-delete" onClick={ () => {
										this.delete(i);
									} }>
										Eliminar
									</button>
									<button className="btn btn-transparent" onClick={ () => {
										this.viewFiles(i);
									} }>
										Permisos
									</button>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Vehicles);